// com.ic2.auth.refresh.SessionManagementServiceI generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';
import { ActiveSessionDTO } from '../entities/ActiveSessionDTO';

@Injectable({
  providedIn: 'root',
})
export class SessionManagementService {
  private irpc = inject(IRPC);

  getActiveSessions = (): RpcRequestBuilder<ActiveSessionDTO[]> => {
    const req = new JSONRpcRequest();
    req.method = 'SessionManagementService.getActiveSessions';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, 'java.util.List');
  };

  revokeAllOtherSessions = (): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'SessionManagementService.revokeAllOtherSessions';
    req.params = [];
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  revokeSession = (idRefreshToken: number): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'SessionManagementService.revokeSession';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(idRefreshToken, 'java.lang.Integer', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
